import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';

const PrivateLayout = ({ children }) => {
  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      <main className="flex-grow">
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default PrivateLayout;
